<template>
  <header class="header">
    <bb-navbar
      sticky
      flavor="public"
      :close-button="isAuthenticatedApplicant"
      logo-to="https://www.bigbank.fi/"
      @closeClick="logout"
    />
  </header>
</template>

<script>
  import { BbNavbar } from '@bigbank/interface-components';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'app-header',

    components: { BbNavbar },

    computed: { ...mapGetters('auth', ['isAuthenticatedApplicant']) },

    methods: { ...mapActions('auth', ['logout']) },
  };
</script>

<style lang="scss" scoped>
  .divider {
    height: 40px;
    margin: 0 25px 0 20px;
    border-left: 1px solid $gray-20;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .container-ie {
      position: absolute;
      left: 25%;
      padding-top: 10px;
    }
    .progress-bar-ie {
      left: 0;
    }
  }
</style>
